import {createSelector} from 'reselect';
import {getListingPage, getTranslations} from './store';
import {getBookingUrl} from './bookingUrl';
import {getTotals} from './priceDetails';
import {getCurrentError} from './tripAlert';
import getPriceStatus from './priceStatus';
import {getBookingType} from './listing';

// Determines if price should be shown
const getShowPrice = createSelector(
    [getListingPage, getCurrentError, getPriceStatus],
    (listingPage, currentError, priceStatus) => {
        const {loadingRate} = listingPage;

        const {isAvailable} = priceStatus;

        return !loadingRate && !currentError && isAvailable;
    }
);

const getBookingModalData = createSelector(
    [
        getCurrentError,
        getBookingType,
        getTotals,
        getTranslations,
        getBookingUrl,
        getListingPage,
        getShowPrice
    ],
    (currentError, bookingType, totals, translations, bookingUrl, listingPage, showPrice) => {
        const labels = {
            title: translations.bookingSummary,
            continueButton: translations.onlineBookingModalContinue,
            cancellationPolicyHeader: translations.cancellationPolicyHeader
        };

        if (!bookingType.onlineBookable) {
            labels.continueButton = translations['internal-components.contact-host.call-to-action'];
        }

        return {
            labels,
            ctaEnabled:
                (!listingPage.loadingRate && bookingUrl && !!bookingUrl.length && !currentError) ||
                !bookingType.onlineBookable,
            showCancellationPolicy: totals && Object.keys(totals).length > 0,
            showPrice
        };
    }
);

export default getBookingModalData;

export {getBookingModalData, getShowPrice};
